import { useAppVersion } from 'hooks/useAppVersion'
import { RefreshCw, X } from 'lucide-react'
import { useEffect, useState } from 'react'
import { Button } from './Button'
import IconButton from './Button/IconButton'

/**
 * Componente que exibe notificação quando há uma nova versão disponível
 * Permite ao usuário recarregar a aplicação para obter a atualização
 */
export function UpdateNotification() {
    const { isUpdateAvailable, latestVersion, currentVersion, reloadApp } =
        useAppVersion()
    const [isVisible, setIsVisible] = useState(false)
    const [isDismissed, setIsDismissed] = useState(false)

    useEffect(() => {
        if (isUpdateAvailable && !isDismissed) {
            // Aguarda um pouco antes de mostrar a notificação
            const timer = setTimeout(() => {
                setIsVisible(true)
            }, 1000)

            return () => clearTimeout(timer)
        } else {
            setIsVisible(false)
        }
    }, [isUpdateAvailable, isDismissed])

    const handleDismiss = () => {
        setIsDismissed(true)
        setIsVisible(false)
    }

    const handleUpdate = () => {
        reloadApp()
    }

    if (!isVisible) {
        return null
    }

    return (
        <div className="fixed bottom-4 right-5 z-(--z-flutuante) max-w-md animate-in slide-in-from-bottom-5">
            <div className="bg-card rounded-lg shadow-md border p-4">
                <div className="flex items-start gap-3">
                    <div className="flex-shrink-0">
                        <div className="w-10 h-10 rounded-full bg-primary/20 flex items-center justify-center">
                            <RefreshCw className="size-5 text-foreground" />
                        </div>
                    </div>

                    <div className="flex-1 min-w-0">
                        <h3 className="text-sm font-semibold text-foreground">
                            Nova versão disponível!
                        </h3>
                        <p className="mt-1 text-sm text-secondary-foreground">
                            Uma atualização está disponível. Recarregue a página
                            para obter a versão mais recente.
                        </p>
                        <div className="mt-2 text-xs text-secondary-foreground">
                            {currentVersion} → {latestVersion}
                        </div>

                        <div className="mt-3 flex gap-2">
                            <Button onClick={handleUpdate}>
                                Atualizar agora
                            </Button>
                            <Button onClick={handleDismiss} variant="outlined">
                                Depois
                            </Button>
                        </div>
                    </div>

                    <IconButton
                        onClick={handleDismiss}
                        className="flex-shrink-0 rounded-full p-2"
                        aria-label="Fechar notificação"
                    >
                        <X className="size-5" />
                    </IconButton>
                </div>
            </div>
        </div>
    )
}
